import { useRef } from "react";
import menuOnClick from "../menuOnClick";
import ModalPop from "../../home/ModalPop";

const BannerQuick = () => {
  // const popupRef = useRef<HTMLDivElement>(null);

  // const openfunc = () => {
  //   popupRef.current!.style.display = "block";
  // };

  // const closefunc = () => {
  //   popupRef.current!.style.display = "none";
  // };
  return (
    <div className="hidden lg:block absolute right-6 3xl:right-[calc((100%-var(--container))/2)] top-1/4 w-fit h-fit">
      {/* <ModalPop popupRef={popupRef} closefnc={closefunc} /> */}
      <div className="relative w-52 h-full text-center text-black cursor-pointer">
        <div className=" relative w-fit h-full mx-auto">
          <img
            src="/images/quick1.png"
            alt="장인배관 퀵메뉴"
            className="!relative w-full h-full max-w-36 mr-6"
          />
        </div>
        <div className=" relative w-full h-fit py-0.5 bg-point text-primary rounded-lg">
          <p>장인배관 퀵메뉴</p>
        </div>
        <div
          onClick={() => menuOnClick("#about")}
          className=" relative w-full h-fit py-0.5 bg-white rounded-lg my-3"
        >
          <p>회사소개</p>
        </div>
        <div
          onClick={() => menuOnClick("#service")}
          className=" relative w-full h-fit py-0.5 bg-white rounded-lg my-3"
        >
          <p>서비스 목록</p>
        </div>
        <div
          onClick={() => menuOnClick("#blog")}
          className=" relative w-full h-fit py-0.5 bg-white rounded-lg my-3"
        >
          <p>
            <span className="text-[#1a8300]">BLOG</span> 작업사례
          </p>
        </div>
        <div
          onClick={() => menuOnClick("#equip")}
          className=" relative w-full h-fit py-0.5 bg-white rounded-lg my-3"
        >
          <p>최신장비</p>
        </div>
        <div
          onClick={() => menuOnClick("#contact")}
          className=" relative w-full h-fit py-0.5 bg-white rounded-lg my-3"
        >
          <p>상세 견적문의</p>
        </div>
        <div
          onClick={() => window.open("https://open.kakao.com/o/sD0a2Mmi")}
          className=" relative w-full h-fit my-3"
        >
          <img src="/images/quick2.png" alt="장인배관 카카오톡 상담 바로가기" />
        </div>
        <div
          onClick={() => window.open("https://blog.naver.com/easthans")}
          className=" relative w-full h-fit my-3"
        >
          <img src="/images/quick3.png" alt="장인배관 네이버 블로그 바로가기" />
        </div>
      </div>
    </div>
  );
};

export default BannerQuick;
